module.exports = __webpack_public_path__ + "img/Rectangle 240663466.5b602b53.png";